<template>
<div>
  <el-dialog lock-scroll :close-on-click-modal="false"
    title="关联喜悦汇账号"
    :visible.sync="show"
    width="30%"
    :before-close="close"
    >
    
    <el-tabs v-model="lineType" type="card" @tab-click="handleClick">
      <el-tab-pane label="绑定已有" name="1">
        <!-- <div class="linkUserAvatarBox" v-if="linkData.slowLifeUserId">
          <Avatar :src="linkData.customHeadImgUrl" :name="linkData.memo" />
        </div> -->
        <el-select style="width:70%"
          v-model="tempSelectUser.id"
          filterable
          remote
          clearable
          default-first-option
          placeholder="请输入搜索"
          no-data-text="找不到用户"
          @clear="doResetSyncUserList"
          @change="doUserChange"
          :remote-method="doUserSelect"
          >
          <el-option
            v-for="item in syncUserList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
            <span style="float: left"><Avatar size="small" :src="item.headImg.thumbUrl" fit="cover"></Avatar></span>
            <span style="float: right;">{{ item.name }}</span>
            
          </el-option>
        </el-select>
        
        <el-button style="width:20%" type="primary" @click="doLinkSubmit" class="ml-10" :disabled="!tempSelectUser.id">保 存</el-button>
      </el-tab-pane>
      <el-tab-pane label="同步创建并绑定" name="2">
        <el-form :model="formData" label-width="80px" size="small">
          <el-form-item label="头像">
            <div style="height:60px;overflow:hidden;width:60px;"><Avatar :src="formData.newCustomHeadImgUrl">
              <div class="avatar-uploader">
                <input type="file" name="file" accept="image/*" ref="upload"  @change="doUpload">
                <div class="uploadBoxInAvatar">
                  <div class="icon"><i class="el-icon-camera" /></div>
                </div>
              </div>  
            </Avatar></div>
          </el-form-item>
          <el-form-item label="用户名">
            <el-input v-model="formData.newMemo" autocomplete="off" style="width:200px"></el-input>
          </el-form-item>
          <el-form-item label="城市/地区">
            <el-input v-model="formData.city" autocomplete="off" style="width:200px"></el-input>
          </el-form-item>
          <el-form-item label="领域">
            <el-input v-model="formData.field" autocomplete="off" style="width:200px"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary" @click="doLinkSubmit" :loading="isSyncLoading">保 存</el-button>
          </el-form-item>
        </el-form>
        
        
      </el-tab-pane>
    </el-tabs>
    
  </el-dialog>
</div>

</template>

<script>
export default {
  name: 'UserBind',
  props: {
    data: Object,
    show: Boolean,
  },
  data(){
    
    return {
      formData:{
        memo:"",
        newMemo:"",
        newCustomHeadImgUrl:"",
        city:"",
        field:""
      },
      tempSelectUser:{id:""},
      syncUserList:[],
      isSyncLoading:false,
      lineType:"1"
    }
  },
  watch: {
    data(newData){
      console.log('UserBind',newData);
      var data = this.$root.copy(newData);
      this.formData = data;
      this.initData();
    }
  },
  
  methods:{
    initData(){
      this.lineType = "1";
      if(typeof this.formData.memo == 'undefined'){
        this.$set(this.formData, 'memo', '');
      }

      this.$set(this.formData, 'newMemo', this.formData.fullName);
      this.$set(this.formData, 'newCustomHeadImgUrl', this.formData.headImgUrl);

      // 新建喜悦汇扩展字段
      this.$set(this.formData, 'city', '');
      this.$set(this.formData, 'field', '');

      // 重置缓存用户
      this.$set(this, 'tempSelectUser', {id:""});
      

      if(this.formData.slowLifeUserId){
        this.tempSelectUser.id = this.formData.slowLifeUserId;
        this.syncUserList = [{
          id:this.formData.slowLifeUserId,name:this.formData.memo,
          headImg:{thumbUrl:this.formData.customHeadImgUrl}
        }];
      } else {
        this.syncUserList = [];
      }
      
    },
    async doLinkSubmit(){
      var params = {};
      var callback = ()=>{
        this.close();
        this.$emit('update:data',{
          ...this.data, ...params
        });
        console.log({
          ...this.data, ...params
        });
      }
      if(this.lineType == "1"){
        params.slowLifeUserId = this.tempSelectUser.id;
        params.memo = this.tempSelectUser.name;
        params.customHeadImgUrl = this.tempSelectUser.headImg.url.split("?")[0];
      } else {
        
        if(!this.formData.newMemo){
          this.$message.warning("用户名不能为空");
          return ;
        } 
        params.memo = this.formData.newMemo; //仅作触发更新
        params.name = this.formData.newMemo;

        if(!this.formData.city){
          this.$message.warning("城市/地区不能为空");
          return ;
        } 
        params.city = this.formData.city;

        if(!this.formData.field){
          this.$message.warning("领域不能为空");
          return ;
        }
        params.field = this.formData.field;

        params.headUrl = this.formData.newCustomHeadImgUrl;
        params.userId = this.formData.userId;

        var famousPerson = await this.request.post(`/api/v1/slowlifes/famous/persons`,params).then(res=>{
          if(!res){return;}
          return res;
        });

        params.slowLifeUserId = famousPerson.id;
        params.customHeadImgUrl = famousPerson.headImg.url.split("?")[0];
        delete params.userId;
        delete params.name;
        delete params.city;
        delete params.field;
        delete params.headUrl;

        console.log(JSON.stringify(params));




        // await this.doUserSave({customHeadImgUrl:this.formData.customHeadImgUrl.split("?")[0]},()=>{
        //   this.request.post(`/api/v1/slowlifes/famous/persons`,{
        //     userId:this.data.userId,
        //     city:this.linkData2.city,
        //     field:this.linkData2.field,
        //     customHeadImgUrl:this.linkData2.customHeadImgUrl,
        //     name:this.linkData2.memo,
        //   }).then(res=>{
        //     if(!res){return;}
        //     this.doUserSave({slowLifeUserId:res.id,customHeadImgUrl:this.linkData2.customHeadImgUrl.split("?")[0]},()=>{


        //       this.formData.slowLifeUserId = res.id;
        //       this.formData.customHeadImgUrl = this.linkData2.customHeadImgUrl;
        //       this.formData.memo = this.linkData2.memo;
        //       this.isShowlinkBox = false;

              
        //       this.lineType = "1";
        //       this.linkData2 = {
        //         slowLifeUserId:"",
        //         customHeadImgUrl:"",
        //         memo:"",
        //         city:"",
        //         field:""
        //       };
        //     })
            

        //   })
        // });

        


      }

      await this.doUserSave(params,callback);
      
    },
    doUserChange(id){
      var item = this.syncUserList.find(d=>d.id==id);
      if(item && id){
        // this.formData.memo = item.name;
        this.$set(this,'tempSelectUser',item);
        this.$set(this,'syncUserList',[]);
        // this.formData.id = item.id;
        // this.formData.customHeadImgUrl = item.headImg.thumbUrl.split("?")[0];
      } else {
        this.formData.memo = this.data.memo || "";
        this.formData.slowLifeUserId = this.data.slowLifeUserId || "";
        this.formData.customHeadImgUrl = this.data.customHeadImgUrl || "";
      }
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    doResetSyncUserList(){
      this.syncUserList = [];
    },
    async doUserSelect(query){
      if (query !== '') {
        this.syncUserList = await this.request.get(`/api/v1/slowlifes/famous/persons?page=1&size=20&keyword=${query}`).then( async res=>{
          if(!res)return [];
          else return res.results || [];
        });
      } else {
        this.syncUserList = [];
      }
    },
    doUpload(event){
      if(!event.target.value){return;}
      var file = event.target.files[0];
      let formData = new FormData();
      formData.set("file", file);

      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      
      this.request.post(`/api/v1/oss/upload`,formData).then(customHeadImgUrl=>{
        loading.close();
        this.$refs.upload.value = null;
        
        if(!customHeadImgUrl){this.formData.newCustomHeadImgUrl = ""; return;}
        this.formData.newCustomHeadImgUrl = customHeadImgUrl;
        // this.doUserSave({customHeadImgUrl});
      });
    },
    close(){
      this.initData();
      this.$emit('update:show',false);
    },
    async doUserSave(params,callback=()=>{}){
      if(params.memo){
        await this.request.post(`/api/v1/users/${this.formData.userId}/remark`,{memo:params.memo}).then(res=>{
          return !!res;
        });
      }
      return await this.request.put(`/api/v1/users/${this.formData.userId}`,params).then(async res=>{
        this.isSyncLoading = false;
        this.$message.success("保存成功");
        callback();
        return res;
      });
    }
  },
}
</script>

<style scoped lang="less">
.uploadBox{
  text-align: center;
  background: #C0C4CC;
  border-radius: 50%;
  width:60px;
  height:60px;
  font-size:26px;
  color:#fff;
  line-height: 1;
  overflow: hidden;
  position: relative;
  .icon{
    margin-top:5px;
    width: 100%;
  }
  .text{
    width: 100%;
    font-size:12px;
  }
  
}
.avatar-uploader{
  opacity: 0;
  -webkit-transition: opacity .3s;  
  -moz-transition: opacity .3s;  
  -ms-transition: opacity .3s;  
  -o-transition: opacity .3s;  
  transition: opacity .3s;  
  position: absolute;
  top: 0px;
  font-size:30px;
  text-align: center;
  left: 0;
  right: 0;
  bottom:0;
  cursor: pointer;
  color:#aaa;
  &:hover{
    opacity: 1;
  }
  &::before{
    content:"";
    z-index: 1;
    font-size: 0;
    border-radius: 50%;
    position: absolute;
    top:0;left:0;right:0;bottom:0;
    background: rgba(0, 0, 0, .5);
  }
}

input[type='file']{
  opacity: 0;
  z-index: 3;
  cursor: pointer;
  position: absolute;
  top:0;left:0;right:0;bottom:0;
}

.uploadBoxInAvatar{
  opacity: 1;
  z-index: 2;
  position: absolute;
  left: 50%;top:50%;
  transform: translateX(-50%) translateY(-50%);
}

.linkUserAvatarBox{
  
}
</style>
